import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import "./assets/scss/dashlite.scss";
import "./assets/scss/style-email.scss";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import store from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

let persistor = persistStore(store);

const Error404Modern = lazy(() => import("./pages/error/404-modern"));

const RootRouter = () => {
  const location = useLocation();
  const is404 = location.state && location.state.is404;

  return is404 ? (
    <Error404Modern />
  ) : (
    <PersistGate persistor={persistor}>
      <App />
      <ToastContainer />
    </PersistGate>
  );
};

const root = createRoot(document.getElementById("root"));

root.render(
  <React.Fragment>
    <Provider store={store}>
      <Suspense fallback={<div />}>
        <Router
          basename={`/`}
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="*" element={<RootRouter />} />
          </Routes>
        </Router>
      </Suspense>
    </Provider>
  </React.Fragment>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
